import React from "react";
import { Info } from "lucide-react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { frontendCapabilities, IS_STATIC_DEMO_FRONTEND } from "../../globals";

/** Card that opens the pages about captured work in the web service and the demo, and
 * scrolls away with them: neither can capture work, which is what the desktop app is for. */
const LimitedFunctionalityBanner = () => {
  const { t } = useTranslation();
  if (frontendCapabilities.localRecording) return null;
  return (
    // Padded like a dashboard page, so the card lines up with the content under it, and
    // pulled into that page's top padding, which alone leaves the title too far below.
    <div className="-mb-2 px-4 pt-5 sm:px-8">
      <div className="flex items-start gap-3 rounded-xl border border-info/25 bg-info/10 px-4 py-3 text-sm text-info-strong">
        <Info size={18} className="mt-0.5 shrink-0" />
        <p>
          <Trans
            i18nKey={
              IS_STATIC_DEMO_FRONTEND
                ? "static_demo_limited_functionality_banner"
                : "web_service_limited_functionality_banner"
            }
            components={{ strong: <strong /> }}
          />{" "}
          <Link to="/downloads/" className="font-medium underline underline-offset-2">
            {t("download_platonic_desktop")}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LimitedFunctionalityBanner;
